import { useState } from "react";
import { Row, Col, Button, Label, Form } from "reactstrap";
import ThemeModal from "components/Common/ThemeModal";
import InputField from "components/Common/InputField";
import { usePettyCashBillPay } from "hooks/usePettyCashBills";

const PettyCashBillPay = ({ modal, toggleModal, bill }) => {
  const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split("T")[0]);
  const [amount, setAmount] = useState(bill?.due_amount || 0);
  const { mutateAsync: payBill } = usePettyCashBillPay();

  const handleSubmit = async () => {
    await payBill(bill.id, { payment_date: paymentDate, amount });
    toggleModal();
  };

  return (
    <ThemeModal isOpen={modal} toggle={toggleModal} title={`Pay Bill ${bill.bill_no}`}>
      <Form>
        <Row>
          <Col sm={6}>
            <Label>Payment Date</Label>
            <InputField type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
          </Col>
          <Col sm={6}>
            <Label>Amount</Label>
            <InputField type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
          </Col>
        </Row>

        <div className="text-end mt-3">
          <Button color="success" onClick={handleSubmit}>Pay</Button>
        </div>
      </Form>
    </ThemeModal>
  );
};

export default PettyCashBillPay;